import { formatDate, ia } from 'lib/helpers/utility';

import {
  PATIENT_FORM_OPTIONS,
  PATIENT_PRACTICE_OPTIONS
} from 'components/shared/Filters/lib/filterOptions';

import Actions from '../components/Actions';
import FormsTippy from '../components/FormsTippy';

import { getCountOfForms, handleForms, handleFormsStatus } from './helper';

export const defaultColumns = (timezone) => [
  {
    field: 'practice_name',
    headerName: 'Practice',
    cellClass: 'no-border'
  },
  {
    field: 'creator',
    headerName: 'Provider',
    cellClass: 'no-border',
    valueFormatter: ({ value }) => (ia(value) ? value.map((v) => `${v?.f_name} ${v?.l_name}`) : '-')
  },
  {
    field: 'appointment.starts_at',
    headerName: 'Date of Service',
    cellClass: 'no-border',
    valueFormatter: ({ value }) => (value ? formatDate(value, timezone) : '-')
  },
  {
    field: 'forms',
    headerName: 'Forms',
    cellClass: 'no-border',
    sortable: false,
    cellRenderer: (params) => <FormsTippy data={params?.data} formCallBack={handleForms} />
  },
  {
    field: 'no-completed-forms',
    headerName: 'No. of Completed Forms',
    cellClass: 'no-border',
    sortable: false,
    valueFormatter: (params) => getCountOfForms(params?.data)
  },
  {
    field: 'completed-forms',
    headerName: 'Completed Forms',
    cellClass: 'no-border',
    sortable: false,
    cellRenderer: (params) => (
      <FormsTippy data={params?.data} formCallBack={(value) => handleFormsStatus(value, true)} />
    )
  },
  {
    field: 'incomplete-forms',
    headerName: 'Incomplete Forms',
    cellClass: 'no-border',
    sortable: false,
    cellRenderer: (params) => (
      <FormsTippy data={params?.data} formCallBack={(value) => handleFormsStatus(value, false)} />
    )
  },
  {
    field: 'created_at',
    headerName: 'Created At',
    cellClass: 'no-border',
    valueFormatter: ({ value }) => (value ? formatDate(value, timezone) : '-')
  },
  {
    field: 'expires_at',
    headerName: 'Link Expires On',
    cellClass: 'no-border',
    valueFormatter: ({ value }) => (value ? formatDate(value, timezone) : '-')
  },
  {
    field: 'actions',
    headerName: 'Actions',
    cellClass: 'no-border',
    cellRenderer: Actions,
    maxWidth: 88,
    minWidth: 36,
    resizable: false,
    sortable: false,
    pinned: 'right'
  }
];

export const DEFAULT_FILTERS = {
  created_at: {
    type: 'date-range',
    title: 'Created At',
    icon: 'calendar-mono'
  },
  practice: PATIENT_PRACTICE_OPTIONS,
  provider: {
    title: 'Provider',
    placeholder: 'Search by provider name',
    icon: 'user-square-mono',
    allowed_operators: ['contains', 'does not contain']
  },
  form: PATIENT_FORM_OPTIONS
};
